<template>
	<div>
		<app-navbar v-if="ninja" :isOpen="opened" @toggle-menu="toggleSidebar"/>
		<main slot="content" id="content" class="content" role="main">
			<div class="container col-md-12">
				<app-breadcrumbs v-if="ninja"/>
			</div>
			<vuestic-pre-loader v-show="isLoading" class="pre-loader"></vuestic-pre-loader>
			<router-view v-on:onPresenca="onPresenca" v-on:onEAD="onEAD" ></router-view>
		</main>
		<span class="footer">©{{getDateYearActual()}} - FábricaInfo</span> 
	</div>
</template>

<script>

import AppNavbar from './app-navbar/AppNavbar'
import AppBreadcrumbs from './app-breadcrumbs/AppBreadcrumbs'
import Layout from 'vuestic-theme/vuestic-directives/Layout'
import { mapGetters } from 'vuex'

export default {
	name: 'app-layout',

	components: {
		AppNavbar,
		AppBreadcrumbs
	},

	directives: {
		layout: Layout,
	},

	data () {
		return {
			opened: true,
			ninja: true,
		}
	},

	methods: {

		getDateYearActual () {
			let dt = new Date()
			return dt.getFullYear()
		},

		toggleSidebar (opened)
        {
			this.opened = opened
		},

		onPresenca (value) {
			this.$data.ninja = value
		},

		onEAD (value) {
			this.$data.ninja = value
		}

	},

	computed: {
		...mapGetters([
			'isLoading'
		])
	}
}

</script>
